import type { MongoQuery } from '@ucast/mongo2js'

// Minimal structural shape of the better-auth session consumed here.
// Declared locally to avoid a workspace dependency cycle with `auth`
// (auth depends on `ability` for its access-control config).
// The full `auth` Session is structurally assignable to this type.
export type Session = {
    session: {
        activeOrganizationId?: string | null
        organizationRole?: string | null
    }
    user: {
        id?: string
        role?: string | null
    }
}

export enum Audience {
    Backoffice = 'backoffice',
    Frontoffice = 'frontoffice',
    System = 'system',
    Public = 'public',
}

export enum Subject {
    All = 'all',
    Todo = 'todo',
    User = 'user',
    Chat = 'chat',
    Agent = 'agent',
    SubAgent = 'subAgent',
    Document = 'document',
    AgentDocument = 'agent_document',
    AgentAnalytic = 'agent_analytic',
    McpServer = 'mcp_server',
    Media = 'media',
    RevisedAnswer = 'revised_answer',
    Organization = 'organization',
    Member = 'member',
    Lead = 'lead',
    MessageFeedback = 'message_feedback',
    Backoffice = 'backoffice',
    Frontoffice = 'frontoffice',
    System = 'system',
    Invitation = 'invitation',
    Crawler = 'crawler',
    ReasoningChat = 'reasoning_chat',
    TimeTrackerChat = 'time_tracker_chat',
    OrganizationExternalAuth = 'organization_external_auth',
    AgentEndpoint = 'agent_endpoint',
    AgentEndpointLog = 'agent_endpoint_log',
    AgentApiTool = 'agent_api_tool',
    DocumentFolder = 'document_folder',
    Integration = 'integration',
    Notification = 'notification',
    PlatformConnection = 'platform_connection',
}

// action
export type Action =
    | 'create'
    | 'read'
    | 'update'
    | 'delete'
    | 'manage'
    | 'impersonate'
    | 'invite'
    | 'access'
    | 'clone'
    | 'ban'
    | 'unban'
    | 'change-role'
    | 'resend'
    | 'cancel'
    | 'execute'
    | 'refill'

export type Capability = {
    action: Action
    subject: Subject
    fields?: string[]
    condition?: MongoQuery
    inverted?: boolean
}

export type CapabilitiesFactory = (
    currentSession?: Session | null,
) => Capability[]
